(function () {
  if (window.RSReveal) return;
  window.RSReveal = true;

  // The inline snippet script adds .rs-reveal-ready before first paint;
  // if it didn't run (no IO support / reduced motion), leave everything visible.
  if (!document.documentElement.classList.contains('rs-reveal-ready')) return;

  var STAGGER = 0.12;

  function reveal(el) {
    if (el.hasAttribute('data-rs-reveal-group')) {
      Array.prototype.forEach.call(el.children, function (child, i) {
        child.style.setProperty('--rs-reveal-delay', (i * STAGGER).toFixed(2) + 's');
      });
    }
    // Double rAF guarantees the hidden state has painted before the class
    // flips, so above-the-fold elements transition instead of snapping in.
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        el.classList.add('is-revealed');
      });
    });
  }

  function init() {
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          reveal(entry.target);
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.05 }
    );

    document
      .querySelectorAll('[data-rs-reveal]:not(.is-revealed), [data-rs-reveal-group]:not(.is-revealed)')
      .forEach(function (el) {
        observer.observe(el);
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-scan when the theme editor re-renders a section
  document.addEventListener('shopify:section:load', init);
})();
